// @ts-nocheck
import { useState, useEffect, useRef } from 'react';
import { CloudSlash, CloudCheck } from '@phosphor-icons/react';
import { useOnlineStatus } from '../../context/OnlineStatusContext/OnlineStatusContext';
import './OfflineIndicator.css';

const OfflineIndicator = () => {
  const { isOnline } = useOnlineStatus();
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const previousOnlineStatus = useRef(isOnline);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    // Check if status changed from offline to online
    if (!previousOnlineStatus.current && isOnline) {
      // User came back online
      setShowOnlineMessage(true);
      setIsVisible(true);

      // Clear any existing timeout
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }

      // Hide the "back online" message after 3 seconds
      hideTimeoutRef.current = setTimeout(() => {
        setIsVisible(false);
        // Wait for fade out animation before removing from DOM
        setTimeout(() => {
          setShowOnlineMessage(false);
        }, 300);
      }, 3000);
    } else if (!isOnline) {
      // User went offline
      setShowOnlineMessage(false);
      setIsVisible(true);

      // Clear any existing timeout
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    } else if (isOnline && previousOnlineStatus.current) {
      // Still online, hide everything
      setIsVisible(false);
    }

    // Update the previous status
    previousOnlineStatus.current = isOnline;

    // Cleanup timeout on unmount
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, [isOnline]);

  // Don't render if online and not showing the "back online" message
  if (isOnline && !showOnlineMessage) {
    return null;
  }

  return (
    <div
      className={`offline-indicator ${isVisible ? 'offline-indicator--visible' : ''} ${
        showOnlineMessage
          ? 'offline-indicator--success'
          : 'offline-indicator--warning'
      }`}
      role='status'
      aria-live='polite'
    >
      <div className='offline-indicator__content'>
        <div className='offline-indicator__icon'>
          {showOnlineMessage ? (
            <CloudCheck size={20} weight='bold' />
          ) : (
            <CloudSlash size={20} weight='bold' />
          )}
        </div>
        <span className='offline-indicator__text'>
          {showOnlineMessage
            ? 'You are back online'
            : 'You are currently offline'}
        </span>
      </div>
    </div>
  );
};

export default OfflineIndicator;
